import React from "react";
import Header from "../components/Header";
import { Outlet } from "react-router-dom";
import Footer from "../components/Footer";
import Person from "../components/Home/Person";

const RootLayout = () => {
  return (
    <>
      <Header />
      <Person />
      <Outlet />
      <Footer />
    </>
  );
};

export default RootLayout;
